<template>
  <div
    @click="$emit('onClick')"
    @mouseover="hovered = true"
    @mouseleave="hovered = false"
    class="w-full flex cursor-pointer justify-start content-start"
  >
    <button
      class="flex justify-start items-center focus:outline-none text-base uppercase font-sansBold"
      :class="customCssButton"
      :disabled="disabled"
      :type="type"
      :id="id"
    >
      <slot>
        CustomButton
      </slot>
    </button>
    <div
      class="w-full flex items-center pl-2"
    >
      <div
        :class="customCssLine"
        class="border-b transition-all ease-in-out duration-300"
      >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomButton',
  props: {
    id: String,
    type: {
      type: String,
      default: 'button'
    },
    dark: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hovered: false
    }
  },
  computed: {
    customCssButton: function () {
      var toReturn = ''
      if (this.dark) toReturn += ' text-black '
      else toReturn += ' text-white  '

      return toReturn
    },
    customCssLine: function () {
      var toReturn = ''

      if (this.dark) toReturn += ' border-black'
      else toReturn += ' border-white '

      if (!this.disabled) {
        if (!this.hovered) {
          toReturn += ' w-8 '
        } else {
          toReturn += ' w-24 '
        }
      }
      return toReturn
    }
  }
}
</script>
